import { LoadingPage } from '@/components/LoadingPage';
import { graphql } from '@/gql/codegen/gql';
import { useQuery } from '@apollo/client';
import { createFileRoute } from '@tanstack/react-router';
import ReflectionResultContainer from './-container';

type ReflectionResultSearch = {
  timeout?: boolean;
};

export const Route = createFileRoute(
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-result/',
)({
  component: component,
  validateSearch: (search: Record<string, unknown>): ReflectionResultSearch => {
    // validate and parse the search params into a typed state
    return {
      timeout: search.timeout === 'true' || search.timeout === true,
    };
  },
});

export const GET_REFLECTION_RESULT = graphql(/* GraphQL */ `
  query GetReflectionResult(
    $input: CourseLessonReflectionResultInput!
    $embaUserAttendanceSlug: String!
    $embaCourseLessonSlug: String!
  ) {
    embaReflectionResult(
      input: $input
    ) {
      ...ReflectionResult
    }
    embaCourseLesson(
      embaUserAttendanceSlug: $embaUserAttendanceSlug
      embaCourseLessonSlug: $embaCourseLessonSlug
    ) {
      ...EmbaCourseLessonDetail
    }
  }
`);

function component() {
  const { userAttendanceSlug, lessonSlug } = Route.useParams();
  const { timeout } = Route.useSearch();

  // ポーリング時にローディング表示を避けるため、useSuspenseQuery ではなく useQuery を使用
  const { startPolling, stopPolling, error, data } = useQuery(
    GET_REFLECTION_RESULT,
    {
      variables: {
        input: {
          embaUserAttendanceSlug: userAttendanceSlug,
          embaCourseLessonSlug: lessonSlug,
        },
        embaUserAttendanceSlug: userAttendanceSlug,
        embaCourseLessonSlug: lessonSlug,
      },
      notifyOnNetworkStatusChange: false,
    },
  );

  if (error) {
    throw error;
  }

  // useQuery を使用しているので、手動でローディングの制御が必要。
  // ローディングは、初回データ取得時（data = undefined）のみ表示させ、ポーリング中(data = キャッシュされた値を保持し続ける)は表示させない。
  if (!data) {
    return <LoadingPage />;
  }

  return (
    <ReflectionResultContainer
      reflectionResult={data.embaReflectionResult}
      courseLesson={data.embaCourseLesson}
      userAttendanceSlug={userAttendanceSlug}
      lessonSlug={lessonSlug}
      startPolling={startPolling}
      stopPolling={stopPolling}
      isTimeout={!!timeout}
    />
  );
}
